'use client'

import { useI18n } from "@/components/I18nProvider"

export function LanguageToggle({ className = "" }: { className?: string }) {
  const { locale, setLocale } = useI18n()

  return (
    <div className={`inline-flex items-center gap-1.5 rounded-2xl border border-[#bfece5] bg-white/78 px-1.5 py-1 text-xs font-semibold dark:border-white/20 dark:bg-white/10 ${className}`}>
      <button
        type="button"
        onClick={() => setLocale("es")}
        className={`rounded-xl px-2.5 py-1 transition ${locale === "es" ? "bg-[linear-gradient(135deg,#14b8a6,#0f766e)] text-white" : "text-muted hover:bg-[#ecfeff]"}`}
      >
        ES
      </button>
      <button
        type="button"
        onClick={() => setLocale("en")}
        className={`rounded-xl px-2.5 py-1 transition ${locale === "en" ? "bg-[linear-gradient(135deg,#14b8a6,#0f766e)] text-white" : "text-muted hover:bg-[#ecfeff]"}`}
      >
        EN
      </button>
    </div>
  )
}
